import { initializeApp } from "firebase/app";

const firebaseConfig = {
	apiKey: "AIzaSyDEgsryyBkIRQGxGkP9Q4_o-U8nyTA_MpU",
	authDomain: "musicify-3a150.firebaseapp.com",
	databaseURL: "https://musicify-3a150-default-rtdb.firebaseio.com",
	projectId: "musicify-3a150",
	storageBucket: "musicify-3a150.appspot.com",
	messagingSenderId: "455063860431",
	appId: "1:455063860431:web:87ca82369a35d03c8fb3ba",
};

export const app = initializeApp(firebaseConfig);